// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__I1xCc","controls":"styles_controls___g2sv","charLimit":"styles_charLimit__2WzcC","input":"styles_input__2O1vB","send":"styles_send__1hRvj"};